var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-skeleton-wrapper',[_c('div',{staticClass:"tw-w-full tw-p-4 tw-pt-8"},_vm._l((6),function(index){return _c('b-skeleton',{key:index,staticClass:"tw-flex-grow tw-mb-10",attrs:{"height":"50px"}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }